import { IAppStore } from '@models/store.model'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'

interface IOwnProps {
  roles: number[]
  users: number[],
  PublicValidationFragment: any
  children?: ReactNode
}

export const RoleUserChildrenGuard = ({ children, roles, users, PublicValidationFragment }: IOwnProps) => {
  const userState = useSelector((store: IAppStore) => store.user)

  return roles.includes(userState.id_role) || users.includes(userState.id)
    ? (children)
    : (
        PublicValidationFragment
      )
}

export default RoleUserChildrenGuard
